export const English = {
    aboutBespoken: "About Bespoken",
    ourFeatures: "Our Features",
    FAQs: "FAQs",
    contactUs: "Contact Us",
    getTheApp: "Get the App",
    weShopYouSlayPersonalizedPicksThatMatchYourVibe: "We shop. You slay. Personalized picks that match your vibe",
    aboutUs: "About Us",
    fullName: "Full Name",
    emailAddress: "Email Address",
    phoneNumber: "Phone Number",
    message: "Message",
    howCanEeHelpYou: "How can we help you?",
    BespokenFeatures: "Bespoken Features",
    sendAMessage: "Send a Message",
    email: "Email",
    phone: "Phone",
    TermsAConditions: "Terms & Conditions",
    PrivacyPolicy: "Privacy Policy",
    Technozone: "Technozone",
    TermsAndConditions: "Terms and Conditions",
    PrivacyAndPolicy: "Privacy and Policy",
    answers: "Answers",
    WillContactYouAsSoonAsPosible: "Thank you for contact us, Will Contact You As Soon As Posible",
    pleaseFillTheFormInTheRightWay: "Please Fill The Form In The right Way",
    enterYourFullName: "Enter your Full Name",
    enterYourEmail: "Enter your Email",
    enterYourPhoneNumber: "Enter your Phone Number",
    thisFieldIsRequired: "This Field is Required",
    selectYourMomentsOrCity: "Select Your Moments or City",
    shareAnySpaceFromASharedLivingRoomToASecondHomeAndEverythingInBetween: "Share any space from a shared living room to a second home and everything in-between.",
    chooseYourDate: "Choose Your Date",
    youreFreeToChooseYourOwnSchedulePricesAndRequirementsForGuests: "You’re free to choose your own schedule, prices, and requirements for guests.",
    enjoyThePhotoshoot: "Enjoy the Photoshoot",
    onceYourListingIsLiveQualifiedGuestsCanReachOutAndYouCanMessageThem: "Once your listing is live, qualified guests can reach out and you can message them.",
    getYourFilesOnlyOn48Hours: "Get Your files Only in 48 Hours"


};
